import React from 'react'
import L from "leaflet";
import { Marker, Tooltip } from 'react-leaflet'
import { navigateToDetail } from '../Utils/utils';

const CustomMarker = (props) => {
  const {
    id,
    position,
    source,
    redirectRoute,
    name,
    currentZoom,
    isOverview,
  } = props;

  const prefix = ".svg";
  
  let size = {
    width: 65,
    height: 65
  }

  let sizeClass = "c-leaflet-icon-size-65"

  if(currentZoom > 15){
    sizeClass = "c-leaflet-icon-size-50"
  }
  else if(currentZoom >= 13 && currentZoom <= 15 ){
    sizeClass = "c-leaflet-icon-size-55"
  }
  else if(currentZoom >= 11 && currentZoom < 13){
    sizeClass = "c-leaflet-icon-size-60"
  }

  const customMarker = new L.Icon({
    iconUrl: `${source}${prefix}`,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(size.width, size.height),
    className: `leaflet-div-icon ${sizeClass}`,
  });

  const customMarkerActive = new L.Icon({
    iconUrl: `${source}Active${prefix}`,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(size.width, size.height),
    className: `leaflet-div-icon ${sizeClass}`,
  });

  const setIcon = (e) => {
    var marker = e.target;
    marker.setIcon(
      marker.options.icon == customMarker ? customMarkerActive : customMarker
    );
  };

  return (
    <>
      <Marker
        position={L.latLng(position[0], position[1])}
        icon={customMarker}
        eventHandlers={{
          click: (e) => {
            setIcon(e);
            navigateToDetail(id, window, redirectRoute);
          },
        }}  
      >
        {name &&
          <Tooltip>{name}</Tooltip>
        }
      </Marker>
    </>
  );
};

export default CustomMarker;
